import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CancelIcon from "@mui/icons-material/Cancel";
import PaymentsIcon from "@mui/icons-material/Payments";
import ReplayIcon from "@mui/icons-material/Replay";
import SavingsIcon from "@mui/icons-material/Savings";
import { Grid } from "@mui/material";

import { MetricCard } from "../../components/MetricCard";
import { formatCurrencyToShow } from "../../helpers/currency";
import { DashboardFinancialSummary } from "../../interfaces/dashboard";

type Metric = {
    id: string;
    title: string;
    value: string;
    percentage?: number;
    icon: React.ReactNode;
};

interface DashboardMetricsProps {
    data?: DashboardFinancialSummary;
    isLoading: boolean;
}

export function DashboardMetrics({ data, isLoading }: DashboardMetricsProps) {
    const metrics: Metric[] = [
        {
            id: "total_revenue",
            title: "Faturamento Total",
            value: `R$ ${
                formatCurrencyToShow(data?.total_revenue?.current) || 0
            }`,
            percentage: data?.total_revenue?.percentage,
            icon: <PaymentsIcon />,
        },
        {
            id: "cancellations",
            title: "Cancelamentos",
            value: `R$ ${
                formatCurrencyToShow(data?.cancelled_total?.current) || 0
            }`,
            percentage: data?.cancelled_total?.percentage,
            icon: <CancelIcon />,
        },
        {
            id: "refunds",
            title: "Reembolsos",
            value: `R$ ${
                formatCurrencyToShow(data?.refunded_total?.current) || 0
            }`,
            percentage: data?.refunded_total?.percentage,
            icon: <ReplayIcon />,
        },
        {
            id: "wallet_balance",
            title: "Saldo Conta Bolsão",
            value: `R$ ${
                formatCurrencyToShow(data?.wallet_balance?.current) || 0
            }`,
            icon: <AccountBalanceWalletIcon />,
        },
        {
            id: "platform_profit",
            title: "Lucro da Plataforma",
            value: `R$ ${
                formatCurrencyToShow(data?.platform_profit?.current) || 0
            }`,
            percentage: data?.platform_profit?.percentage,
            icon: <SavingsIcon />,
        },
    ];

    return (
        <Grid container spacing={3} mb={3}>
            {metrics.map((metric) => (
                <Grid item xs={12} md={2.4} key={metric.id}>
                    <MetricCard
                        icon={metric.icon}
                        title={metric.title}
                        value={metric.value}
                        percentage={metric.percentage}
                        loading={isLoading}
                    />
                </Grid>
            ))}
        </Grid>
    );
}
